export class DuplicateContactError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DuplicateContactError';
  }
}
